/**
 * The Room's loading placeholder — a card-shaped block of shimmering lines. It uses only the CSS
 * classes from @huaca/ui's styles.css (never any @huaca/ui JS, per the Room's no-auth-coupling rule),
 * and announces itself politely so a screen reader hears "loading" rather than silence.
 */
export function RoomSkeleton({ label = 'טוען…' }: { label?: string }) {
  return (
    <div role="status" aria-live="polite" className="room-skeleton" data-testid="room-skeleton">
      <span className="huaca-visually-hidden">{label}</span>
      <div className="huaca-skeleton huaca-skeleton-title" />
      <div className="huaca-skeleton huaca-skeleton-line" />
      <div className="huaca-skeleton huaca-skeleton-line" />
      <div className="huaca-skeleton huaca-skeleton-line" />
    </div>
  );
}
